module.exports = __webpack_public_path__ + "img/vertical_4_6_8023.873d53b0.png";